import { bl_fi_mst_category_level_setting_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class FiMstCategoryLevelSettingsModel extends BaseContainerModel {
    bl_fi_mst_category_level_setting_hdr: bl_fi_mst_category_level_setting_hdr_RowClass = new bl_fi_mst_category_level_setting_hdr_RowClass();
}
